import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapePinFilledRight extends Shape {
    width = 200;
    height = 200;
    defaultBorderWidth = 12;
    defaultColor = "#000000";
    borderStyleEnabled = false;
    includeText = false;

    setDrawStyle(_: any): void {}

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.save();
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.fill();
        canv.ctx.closePath();

        canv.ctx.globalCompositeOperation = "destination-out";

        canv.ctx.beginPath();
        canv.ctx.lineCap = "round";
        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.75, y + h * 0.5);

        canv.ctx.moveTo(x + w * 0.75, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.6, y + h * 0.3);

        canv.ctx.moveTo(x + w * 0.75, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.6, y + h * 0.7);
        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "black";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "#7C7C91";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="m21.2545 1.5c.6879.00048 1.2455.55846 1.2455 1.24661v18.50679c0 .6881-.5576 1.2461-1.2455 1.2466h-18.50705c-.68838 0-1.24745-.5582-1.24745-1.2466v-18.50679c0-.68844.55907-1.24661 1.24745-1.24661zm-7.4646 6.4636c-.2871-.39351-.8387-.48023-1.2322-.19326-.3934.28697-.4799.83874-.1932 1.23226l1.5574 2.1344h-6.68402c-.48701 0-.88193.3951-.88201.8821 0 .4871.39495.8821.88201.8821h6.75092l-1.6406 2.411c-.2736.4024-.1696.9504.2325 1.2246.4026.2741.9513.1701 1.2254-.2325l2.5791-3.7886c.2098-.3082.2034-.7149-.0163-1.0161z"
                fill="${fill}" fill-rule="evenodd"/>
            </svg>
        `;
    }
}
